/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-02-09 16:29:37
 * @modify date 2022-02-09 16:29:37
 * @desc 插件导出 [ prototype 放第一行]
 */
import Cookies from 'js-cookie';
import './global';
import { ParseToken } from './initialize/parseQuery';
import { StartPhpstatdata } from './initialize/phpstatdata';
import './mamba';
import './pages';
import './prototype';
import Store from './store';
export * from './extension';
export async function getInitial() {
  try {
    if (
      Store.System.AccessToken &&
      !Cookies.get('usertokenUrl') &&
      !Store.UserInfo.isRelOrIsg
    ) {
      Store.System.cookieLoginOut = true;
    }
    await ParseToken();
    // 用户校验
    await Store.System.onVerify();
    StartPhpstatdata();
    Store.Client.onWriteCookie();
    return Store.System.Auth.HydrateAsync;
  } catch (error) {
    console.error('LENG ~ getInitial', error);
  }
}
